import { Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from '@wordpress/element';
import { API } from '../API';
import ComerciosItem from '../ComerciosItem';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

function SliderComerciosGrid({ displaySearchForm, perSlide }) {

  const apiComercios = new API();
  const defaultArgs = {
    posts_per_page: 99,
  }

  const [totalComercios, setTotalComercios] = useState(0);
  const [originalComercios, setOriginalComercios] = useState([]);
  const [entidadesQuery, setEntidadesQuery] = useState();
  const [allEntidades, setAllEntidades] = useState([]);
  
  useEffect(() => {

    const query = {
      posts_per_page: 99,
    };

    apiComercios.loadContent(query).then(response => {
      setOriginalComercios(response.data);
      setTotalComercios(response.data.length);
      setAllEntidades(response.data);
    });

  }, []);

  return (
    <>
      <Swiper
        className={ displaySearchForm === 'false' ? 'mt-2' : '' }
        modules={[Pagination, A11y]}
        spaceBetween={32}
        breakpoints={{
          320: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: perSlide,
            slidesPerGroup: perSlide,
            spaceBetween: 16,
          },
        }}
        slidesPerView={perSlide}
        slidesPerGroup={perSlide}
        freeMode={true}
        pagination={{ 
          clickable: true 
        }}
        scrollbar={{ draggable: true }}
      >
        {allEntidades.map(item => {
          return (
            <SwiperSlide key={item.id}>
              <ComerciosItem id={item.id} title={item.title} logo={item.logo} permalink={item.link} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
}

export default SliderComerciosGrid;